//--------------------------------------------------
// imported classes
//--------------------------------------------------
const ModelTranslator = require('../../core/ModelTranslator')
const ClassFunc = require('../../util/ClassFunc')

/**
 * The Common class works as the common translator
 * for the org(organization) section.
 */
const tbs_model_to_Common = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, ModelTranslator, arguments);
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_to_Common.prototype = {
    'submit': '提交',
    'edit': '编辑',
    'delete': '删除',
    'create': '新建',
    'detail': '详情',
    'confirm': '确认',
    'add': '添加',
    'shift': '移出',
    'import': '导入',
    'cancel': '取消',
    'reset': '重置',
    'add-item-placeholder': '添加项名称',
    'upload-image-oversize': '文件大小不能超过5M',
    'all': '全部',
    'city-region': '城市区域',
    'whole-nation': '全国',
    'sport-type': '运动类型',
    'sport-type-0': '全部',
    'sport-type-1': '足球',
    'sport-type-2': '篮球',
    'sport-type-3': '羽毛球',
    'sport-type-4': '乒乓球',
    'sport-type-5': '网球',
    'sport-type-6': '棒球',
    'sport-type-7': '匹克球',
    'sport-type-8': '橄榄球',
    'sport-type-9': '排球',
    'sport-type-10': '冰球',
    'sport-type-11': '旱地冰球',
    'team-unit': '支',
    'team': '球队',
    'game-unit': '场',
    'game': '比赛',
    'session-unit': '届',
    'match': '赛事',
    'year-unit': '年',
    'group-unit': '组',
    'year': '年',
    'month': '月',
    'day': '天',
    'dat': '日',
    'custom-service': '客服',
    'notification': '通知',
    'match-list': '赛事列表',
    'coming-soon': '即将推出',
    'no-permission': '暂无权限',
    'preview': '预览',
    'player-unit': '位',
    'player': '球员',
    'entry-unit': '次',
    'entry': '参赛',
    'invite': '邀请',
    'basic-info': '基本信息',
    'batch': '批量',
    'weekday-date-time': '$date [$day] $time',
    'weekday-0': '周日',
    'weekday-1': '周一',
    'weekday-2': '周二',
    'weekday-3': '周三',
    'weekday-4': '周四',
    'weekday-5': '周五',
    'weekday-6': '周六',
    'match-game-seq': '# $seq',
    'no-data-placeholder': '-',
    'empty-date-field': '待定', 
    'date-period': '$startDate - $endDate',
    'date': '日期',
    'time': '时间',
    'event': '事件',
    'type': '类型',
    'create-now': '立即新建',
    'optional': '可选',
    'manual-selection': '人工选择',
    'long-term': '长期有效',
    'config': '设置',
    'person': '人',
    'between-min-max': '$min-$max$unit',
    'exact-num': '$num$unit',
    'no-less': '不少于$num$unit',
    'no-more': '不超过$num$unit',
    'no-limit': '不限制',
    'semicolon': '：',
    'comma': '，',
    'copy-succeed': '复制成功！',
    'copy-failed': '复制失败！',
    'gender': '性别',
    'gender-option-0': '未知',
    'gender-option-1': '男',
    'gender-option-2': '女',
    'status': '状态',
    'status-option-1': '启用',
    'status-option-2': '停用',
    'invite-label': '未入驻激活 | 立即邀请',
    'qinglianxijigoushengjizhiguanliyuanchakan': '请联系机构升级至管理员查看',
    'expand': '展开',
    'collapse': '收起',
}

//--------------------------------------------------
// extends the ModelTranslator
//--------------------------------------------------
ClassFunc.extend(tbs_model_to_Common, ModelTranslator);

module.exports = tbs_model_to_Common